<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="荣誉资质" name="1">
      <QyzsRyzz :ryzzID='ryzzID'></QyzsRyzz>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import QyzsRyzz from '../../../../../static/form/xsyz/QyzsRyzz'
export default {
  components: {
    QyzsRyzz
  },
  data()
  {
    return {
      activeName: '1',
      ryzzID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/QyzsZzlbUpdata'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/QyzsZzlbUpdata.vue